export const CONTACT = {
  name: "Timo Roider",
  role: "Physiotherapeut",
  phone: "0170 / 2151500",
  phoneHref: "tel:+491702151500",
  email: "info@physiomobilroider.de",
  street: "Südenstraße 18A",
  city: "85221 Dachau",
  web: "www.physiomobilroider.de",
};

export const SERVICES = [
  {
    id: "krankengymnastik",
    num: "01",
    title: "Krankengymnastik",
    tag: "Aktive Therapie",
    text: "Individuelle Bewegungstherapie zur Wiederherstellung von Kraft, Beweglichkeit und Koordination – abgestimmt auf Ihren Alltag, durchgeführt in Ihrem Zuhause.",
    img: "https://images.pexels.com/photos/20860586/pexels-photo-20860586.jpeg",
  },
  {
    id: "manuelle-therapie",
    num: "02",
    title: "Manuelle Therapie",
    tag: "Gelenk & Struktur",
    text: "Gezielte Handgrifftechniken zur Behandlung von Funktionsstörungen an Gelenken, Muskeln und Nerven. Schmerzlinderung und mehr Bewegungsfreiheit.",
    img: "https://images.unsplash.com/photo-1706353399656-210cca727a33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxwaHlzaW90aGVyYXBpc3QlMjBtYW51YWwlMjB0aGVyYXB5fGVufDB8fHx8MTc4NDM4MDc4OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "massage",
    num: "03",
    title: "Massage",
    tag: "Entspannung & Lösung",
    text: "Klassische Massagetechniken zur Lockerung verspannter Muskulatur, Durchblutungsförderung und Reduktion von Stress – entspannt bei Ihnen daheim.",
    img: "https://images.unsplash.com/photo-1741522509407-41cfe73b0b75?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxtb2JpbGUlMjBtYXNzYWdlJTIwdGhlcmFweSUyMGF0JTIwaG9tZXxlbnwwfHx8fDE3ODYxNzU4MTl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "lymphdrainage",
    num: "04",
    title: "Lymphdrainage",
    tag: "Entstauung",
    text: "Sanfte manuelle Lymphdrainage zur Entstauung des Gewebes bei Ödemen und nach Operationen. Fördert den Abtransport von Flüssigkeit und Regeneration.",
    img: "https://images.pexels.com/photos/20860614/pexels-photo-20860614.jpeg",
  },
];

export const FAQS = [
  {
    q: "Bieten Sie Behandlungen in eigenen Räumen an?",
    a: "Nein. P.M.R. ist eine rein mobile Praxis – ich komme ausschließlich zu Ihnen nach Hause. So sparen Sie sich Anfahrt und Wartezimmer und werden in gewohnter Umgebung behandelt.",
  },
  {
    q: "In welchem Umkreis bieten Sie Hausbesuche an?",
    a: "Dachau und Umgebung. Bei weiteren Entfernungen sprechen Sie mich gerne an – wir finden eine Lösung.",
  },
  {
    q: "Übernimmt meine Krankenkasse die Kosten?",
    a: "P.M.R. ist eine Privatpraxis. Die Behandlung rechne ich privat oder über eine private Krankenversicherung / Beihilfe ab. Gesetzlich Versicherte können die Leistung als Selbstzahler in Anspruch nehmen.",
  },
  {
    q: "Was benötige ich für einen Hausbesuch?",
    a: "Nur etwas Platz und bequeme Kleidung. Die notwendige Ausrüstung bringe ich mit. Eine ärztliche Verordnung ist für Selbstzahler nicht zwingend erforderlich.",
  },
  {
    q: "Wie vereinbare ich einen Termin?",
    a: "Am schnellsten telefonisch unter 0170 / 2151500 oder über das Anfrageformular auf dieser Seite. Ich melde mich zeitnah zur Terminabstimmung.",
  },
];

export const DURATIONS = [
  { value: "30 Minuten", label: "30 Minuten", price: "70 €" },
  { value: "60 Minuten", label: "60 Minuten", price: "100 €" },
];

export const TRAVEL = [
  { area: "Stadtgebiet Dachau", cost: "inklusive" },
  { area: "Umkreis bis 5 km", cost: "+ 10 €" },
  { area: "Umkreis bis 10 km", cost: "+ 20 €" },
];

export const WORKING_HOURS = [
  { day: "Montag – Donnerstag", time: "16:30 – 21:00 Uhr" },
  { day: "Samstag", time: "08:00 – 12:00 Uhr" },
];

export const BOOKING_DAYS = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Samstag"];
export const SLOTS_WEEKDAY = ["16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00", "20:30"];
export const SLOTS_SATURDAY = ["08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30"];

export const NAV = [
  { label: "Über mich", href: "#ueber-mich" },
  { label: "Leistungen", href: "#leistungen" },
  { label: "Preise & FAQ", href: "#preise" },
  { label: "Kontakt", href: "#kontakt" },
];
